import PaymentDetails from './payment-details';
import Alert from './alert';
import CashApp from './cashapp-alert';
import BitcoinProfit from './bitcoin-profit';
import QRCode from './qrcode';

export default {
    BitcoinProfit,
    PaymentDetails,
    Alert,
    QRCode
}